export const USER_PROFILE_TEXT = {
  SUPPORT_ADMIN: 'Support admin',
  SET_PERMISSIONS: 'Set permissions',
  LOG_OUT: 'Log out',
} as const

export const IMPERSONATE_SUPPORT_ADMIN_TEXT = {
  SUCCESS: 'Impersonated support admin successfully.',
  FAILURE: 'Failed to impersonate support admin.',
} as const

export const SET_PERMISSIONS_MODAL_TEXT = {
  TITLE: 'Set view as role permissions (only for front end - does not work for Support User)',
  PRIMARY_BUTTON: 'Apply Permissions',
  SECONDARY_BUTTON: 'Reset to my Permissions',
  STATUS_CUSTOM: 'Using Custom Permissions',
  STATUS_ACTUAL: 'Using Your Actual Permissions',
  AVAILABLE_PERMISSIONS_LABEL: 'Available Permissions',
} as const
